module.exports = __webpack_public_path__ + "img/logo-footer-tat.c674afad.svg";